// react components
import React from 'react'
import {
    useDispatch,
} from 'react-redux'

// pages
import {
    ErrorHelper825,
    FormLabel825,
} from 'pages'

// data
import {
    reduxModalErrorEventHandlerSite,
} from 'data'

// props
type CheckboxInputV2825Props = {
    disabled?: boolean
    error?: string
    helperText?: string
    name: string
    label?: string
    onChange: any
    onKeyPress?: any
    value: any
}

// main
export const CheckboxInputV2825: React.FC<CheckboxInputV2825Props> = React.memo(({
    disabled,
    error,
    helperText,
    label,
    name,
    onChange,
    onKeyPress,
    value,
}) => {

    const dispatch = useDispatch()

    function onInputChange(value: boolean) {
        try {
            onChange({
                name: name,
                value: value,
            })
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'CheckboxInputV2825',
                'onInputChange',
            ))
        }
    }

    if (label) {
        return (
            <div className={`input-wrap-825${disabled ? ' disabled' : ''}`}>
                <div className='input-label-wrap'>
                    <FormLabel825
                        helperText={helperText}
                        label={label}
                        name={name}
                    />
                </div>
                <div
                    className='checkbox-input-825'
                    onClick={() => onInputChange(!value)}
                >
                    <input
                        checked={value || false}
                        className='ci-input'
                        disabled={disabled}
                        name={name}
                        onChange={(e) => undefined}
                        onKeyPress={onKeyPress}
                        type='checkbox'
                    />
                </div>
                <ErrorHelper825 error={error} />
            </div>
        )
    }

    return (
        <div
            className='checkbox-input-825'
            onClick={() => onInputChange(!value)}
        >
            <input
                checked={value || false}
                className='ci-input'
                disabled={disabled}
                name={name}
                onChange={(e) => undefined}
                onKeyPress={onKeyPress}
                type='checkbox'
            />
        </div>
    )
})
